<div class="card">
    <div class="card-header">
        <h5>Invoices</h5>
    </div>
    <div class="card-body">
        <ul class="list-group scrollable" style="height: 296px;">
            <li *ngFor="let invoice of invoices" class="list-group-item" (click)="openInvoice(invoice);">
                <div class="d-flex">
                    <div>
                        <div class="d-flex">
                            <strong>{{invoice.subscription.name}}</strong>
                            @if (invoice?.isPaid){
                            <span class="badge text-bg-success my-auto ms-2">Paid</span>
                            } @else {
                            <span class="badge text-bg-danger my-auto ms-2">Unpaid</span>
                            }
                        </div>
                        <small class="text-muted">Billed on {{invoice.createdAt | date:'longDate':'UTC'}}</small>
                    </div>
                    <div class="ms-auto my-auto fs-4">
                        <span>${{invoice.total}}</span>
                    </div>
                </div>
            </li>
            <li *ngIf="invoices.length == 0" class="list-group-item">No Invoices</li>
        </ul>
    </div>
</div>
